var array = Array.prototype;

export var map = array.map;
export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-scale/src/array.js
// module id = 212
// module chunks = 0